import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '../overlay/overlay.module';
import { ContentTemplate, DropdownComponent } from './dropdown.component';

@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [DropdownComponent, ContentTemplate],
  exports: [DropdownComponent, ContentTemplate],
})
export class DropdownModule {}
